import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import qs from 'query-string';

import Content from 'src/componentes/pages/content';
import { capitalizeFirstLetter } from 'src/utils/string';
import useAuth from 'src/hooks/useAuth';
import Tabs from 'src/componentes/tabs/tabs';
import Tab from 'src/componentes/tabs/tab';
import errorHandler from 'src/utils/error-handler';
import LoadingContainer from 'src/componentes/loading-container';
import http from 'src/services/httpService';
import ContentManager from 'src/componentes/content-manager';

import AcaoEdit from './edit';
import Tarefas from './Tarefas/ListView';
import View from './view';
import {
  ONBOARD_ORIGEM,
  ACAO_INTERACAO_ONBOARD,
  MODULOS,
} from 'src/utils/constants';
import acaoPageSteps from 'src/tours/AcaoPageSteps';
import HintTour from 'src/components/HintTour/HintTour';
import ProactiveTourBox from 'src/components/ProactiveTour/ProactiveTour';
import GraficosAcoes from 'src/paginas/acao/graficos/graficosAcoes';
import SearchSchema from 'src/paginas/acao/search-schema';
import Search from 'src/paginas/acao/search';

const List = ({
  //location,
  afterRemove,
  ignoreStickyHeader = false,
  itemIdOrigin,
  ignoreTour = false,
  iconSettings = true,
  showBackButton = true,
  ...rest
}) => {
  const intl = useIntl();
  const { terms: resources, module } = useAuth();

  const [isLoading, setIsloading] = useState(true);
  const [saved, setSaved] = useState(0);
  const [configurations, setConfigurations] = useState(null);

  const [idFiltroSalvo, setIdFiltroSalvo] = useState(0);
  const [ehFavorito, setEhFavorito] = useState(false);
  const [tipoFiltro, setTipoFiltro] = useState(null);
  const [refreshKeyList, setRefreshKeyList] = useState(0);
  const [refreshKeyGraphics, setRefreshKeyGraphics] = useState(0);

  const getFiltroFavorito = (id, ehFavorito, tipoFiltro) => {
    setIdFiltroSalvo(id);
    setEhFavorito(ehFavorito);
    setTipoFiltro(tipoFiltro);
  };

  const endpoint = '/Acao';
  const filtroId = 5;

  useEffect(() => {
    const getConfigurations = async () => {
      try {
        const response = await http.post(
          `/AcaoConfiguracao/ObterConfiguracoes`,
          {}
        );
        setConfigurations(response.data.model);
      } catch (err) {
        errorHandler(err);
      } finally {
        setIsloading(false);
      }
    };

    getConfigurations();
  }, []);

  const qsObj = window?.location ? qs.parse(window.location.search) : null;
  const itemId = itemIdOrigin ? itemIdOrigin : qsObj && qsObj.itemId;
  const acaoId = qsObj
    ? qsObj.acaoid || qsObj.acaoId || qsObj.id
    : null;
  const controleId = qsObj
    ? qsObj.controleId
      ? qsObj.controleId
      : qsObj.controleId
    : null;
  const tipoItem = qsObj && qsObj.tipoItem;
  const centroCustoId = qsObj && qsObj.centroCustoId;
  const pacoteId = qsObj && qsObj.pacoteId;

  const [showProactiveTour, setShowProactiveTour] = useState(false);
  const [, setOpenHelp] = useState(false);
  const [jaExisteFeedbackAcao, setJaExisteFeedbackAcao] = useState(null);
  const [showHintTour, setShowHintTour] = useState(false);
  const [showProactiveTourDelayed, setShowProactiveTourDelayed] =
    useState(false);

  const isLoadingFeedback = jaExisteFeedbackAcao === null;

  const titleTourBox = intl.formatMessage(
    { id: 'facaUmTourPelaTelaCadastroAcao' },
    { acao: resources.acao }
  );

  const descriptionTourBox = capitalizeFirstLetter(
    intl.formatMessage(
      { id: 'registreGerencieAcao' },
      { planodeacao: resources.planodeacao }
    )
  );

  useEffect(() => {
    setIsloading(true);
    async function fetchOnboardAccess() {
      try {
        const response = await http.post(`/Onboard/ObterDadosAcessoOnboard`, {
          onboardOrigemId: ONBOARD_ORIGEM.CADASTRO_ACAO,
        });

        setShowProactiveTour(!!response?.data);
      } catch (err) {
        errorHandler(err, intl);
      } finally {
        setIsloading(false);
      }
    }
    fetchOnboardAccess();
  }, []);

  useEffect(() => {
    let timeout;
    if (showProactiveTour) {
      timeout = setTimeout(() => setShowProactiveTourDelayed(true), 3000);
    } else {
      setShowProactiveTourDelayed(false);
    }
    return () => clearTimeout(timeout);
  }, [showProactiveTour]);

  const getFeedbackTour = async () => {
    try {
      var response = await http.post(
        'FeedbackTour/ObterFeedbackPorColaborador'
      );
      setJaExisteFeedbackAcao(response.data.value.jaExisteFeedbackAcao);
    } catch (err) {}
  };

  useEffect(() => {
    getFeedbackTour();
  }, []);

  const acaoSteps = !ignoreTour
    ? acaoPageSteps(intl, resources, jaExisteFeedbackAcao, isLoadingFeedback)
    : [];

  const saveOnboardAcess = async (acaoInteracaoOnboardId) => {
    setIsloading(true);
    try {
      http.post(`/Onboard/SalvarAcessoOnboardRedis`, {
        onboardOrigemId: ONBOARD_ORIGEM.CADASTRO_ACAO,
        acaoInteracaoOnboardId: acaoInteracaoOnboardId,
      });

      setIsloading(false);
    } catch (err) {
      errorHandler(err, intl);
    }
  };

  const handleSeeLater = () => {
    saveOnboardAcess(ACAO_INTERACAO_ONBOARD.VER_DEPOIS);
    setShowProactiveTour(false);
    setShowHintTour(true);
  };

  const handleClose = () => {
    saveOnboardAcess(ACAO_INTERACAO_ONBOARD.FECHAR);
    setShowProactiveTour(false);
    setShowHintTour(true);
  };

  const handleCloseTour = () => {
    saveOnboardAcess(ACAO_INTERACAO_ONBOARD.INICIAR_TOUR);
    setShowProactiveTour(false);
    setShowHintTour(true);
  };

  const handleTabChange = (index) => {
    if (index === 0) setRefreshKeyList((prev) => prev + 1);
    else if (index === 2) setRefreshKeyGraphics((prev) => prev + 1);
  };

  const renderDefaultContent = () => (
    <>
      {!ignoreTour &&
        (module?.id == MODULOS.GESTAO_ESTRATEGICA ||
          module?.id == MODULOS.REMUNERACAO_VARIAVEL ||
          module?.id == MODULOS.MATRIZ_ORCAMENTARIA ||
          module?.id == MODULOS.GESTAO_RISCO ||
          module?.id == MODULOS.ESCRITORIO_PROJETOS) &&
        !isLoading &&
        showProactiveTourDelayed && (
          <ProactiveTourBox
            intl={intl}
            title={titleTourBox}
            description={descriptionTourBox}
            onSeeLater={handleSeeLater}
            onClose={handleClose}
            onCloseTour={handleCloseTour}
            setOpenHelp={setOpenHelp}
            steps={acaoSteps}
            redirectPath="/gerenciar/acao"
            tourName={capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'cadastrarAcao' },
                { acao: resources.acao }
              )
            )}
          />
        )}

      {showHintTour && (
        <HintTour intl={intl} setShowHintTour={setShowHintTour} ehAcao={true} />
      )}

      <View
        {...rest}
        location={location}
        afterRemove={afterRemove}
        params={{
          itemId,
          acaoId,
          tipoItem,
          centroCustoId,
          pacoteId,
          controleId,
        }}
        refreshList={saved + refreshKeyList}
        showModal={false}
        stickyHeader={ignoreStickyHeader ? false : true}
        configurations={configurations}
        getFiltroFavorito={getFiltroFavorito}
        search={<Search />}
        searchSchema={SearchSchema}
        filtroId={filtroId}
        endpoint={endpoint}
      />
    </>
  );

  const renderContent = () => {
    if (!configurations.habilitarChecklistTarefas)
      return renderDefaultContent();

    return (
      <Tabs onSelect={handleTabChange}>
        <Tab label={capitalizeFirstLetter(resources.acoes)} key="1">
          {renderDefaultContent()}
        </Tab>
        <Tab label={intl.formatMessage({ id: 'tarefas' })} key="2">
          <Tarefas />
        </Tab>
        <Tab
          label={capitalizeFirstLetter(
            intl.formatMessage({ id: 'label.grafico' })
          )}
          key="3"
        >
          <GraficosAcoes
            key={`graficos-${refreshKeyGraphics}`}
            filtroId={filtroId}
            showSearch={true}
            searchComponent={<Search />}
            searchSchema={SearchSchema}
            url={endpoint}
          />
        </Tab>
      </Tabs>
    );
  };

  const refresh = () => {
    setSaved(saved + 1);
  };

  useEffect(() => {
    if (acaoId && acaoId > 0) {
      ContentManager.addContent(
        <AcaoEdit item={{ id: acaoId }} handleClose={refresh} {...rest} />
      );
    }
  }, [acaoId]);

  return (
    <Content
      titulo={capitalizeFirstLetter(resources.acoes)}
      iconSettings={iconSettings}
      titleSettings={intl.formatMessage(
        {
          id: 'label.configuracoesAcao',
        },
        { acoes: resources.acoes }
      )}
      urlSettings="/configuracoes/acao"
      endPointPermissionSettings="/AcaoConfiguracao/PossuiPermissaoConfiguracao"
      showBackButton={showBackButton}
      iconFavorite={true}
      filtroFavorito={{
        id: idFiltroSalvo,
        ehFavorito: ehFavorito,
        tipoFiltro: tipoFiltro,
      }}
    >
      <LoadingContainer isLoading={isLoading}>
        {configurations ? renderContent() : ''}
      </LoadingContainer>
    </Content>
  );
};

export default List;
